import React, { Component } from 'react';
import PropTypes from 'prop-types';

// Redux
import { connect } from 'react-redux';

// External component
import {Range} from 'rc-slider';


// Redux form
import {change} from 'redux-form';


// Styles
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from '!isomorphic-style-loader!css-loader!rc-slider/assets/index.css';

class FloorHeightRange extends Component {
    static propTypes = {
        min: PropTypes.number.isRequired,
        max: PropTypes.number.isRequired,
        change: PropTypes.any.isRequired,
        handleSubmit: PropTypes.any
    };

    static defaultProps = {
        min: 0,
        max: 0
    };
    
    constructor (props) {
        super(props);
        this.state = {
            minHeight: 0,
            maxHeight: 0
        };
        this.updateValue = this.updateValue.bind(this);
        this.onAfterChange = this.onAfterChange.bind(this);
    }

    componentDidMount() {
        const { min, max, minHeight, maxHeight } = this.props;
        if (minHeight && maxHeight) {
            this.setState({
                minHeight,
                maxHeight
            });
        } else if(min && max) {
            this.setState({
                minHeight: min,
                maxHeight: max
            });
        }
    }

    async updateValue(sliderState) {
        const { change, min, max } = this.props;
        
        if(sliderState && sliderState.length) {
            this.setState({
                minHeight: sliderState[0],
                maxHeight: sliderState[1]
            });
            if (sliderState[0] == min && sliderState[1] == max) {
                await change('SearchForm', 'floorHeightRangeLabel', [min, max]);
            } else {
                await change('SearchForm', 'floorHeightRangeLabel', sliderState);
            }
        }
    }

    async onAfterChange(sliderState){
        const { change, from, base, rates, handleSubmit, min, max } = this.props;
        let minHeight, maxHeight;
        let values = sliderState;
        
        if(sliderState) {
            this.setState({
                minHeight: sliderState[0],
                maxHeight: sliderState[1]
            });
        }

        minHeight = sliderState[0];
        maxHeight = sliderState[1];
        values = [minHeight, maxHeight];
        if (sliderState[0] == min && sliderState[1] == max) {
            await change('SearchForm', 'floorHeightRange', null);
        } else {
            await change('SearchForm', 'floorHeightRange', values);
        }
        await change('SearchForm', 'floorHeightRangeLabel', sliderState);
        await change('SearchForm', 'currentPage', 1);
       // await handleSubmit();
    }
    
    render() {
        const { min, max } = this.props;
        const { minHeight, maxHeight } = this.state;
        
        return (
            <div>
                <Range
                    min={min}
                    max={max}
                    defaultValue={[min, max]}
                    value={[minHeight, maxHeight]}
                    onChange={this.updateValue}
                    onAfterChange={this.onAfterChange}
                    allowCross={true}
                    step={0.1}
                />
            </div>
        );
    }
}

const mapState = (state) => ({
});

const mapDispatch = {
    change
};

export default withStyles(s) (connect(mapState, mapDispatch)(FloorHeightRange));